module.exports = __webpack_public_path__ + "img/badge-list-thumb-112.01f4357b.png";